import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import { useNavigate } from "react-router-dom";
import { aws_base_path } from '../../../config/config';
import { FOOD_TYPE_LABELS } from '../../../constants';
import theme from '../../../theme';
import { Utils } from '../../../utils/utils';

export default function Kitchen(props) {
  const { kitchenData } = props;

  const foodTypes = Array.from(new Set((kitchenData.menus || [])
    .map((menu) => menu.type)
    .filter(Boolean)));

  const servicesText = Utils.getDeliveryMethodText(kitchenData);

  const hasDistance = Number.isFinite(kitchenData.distance);
  const distanceText = hasDistance ? `${kitchenData.distance.toFixed(1)} miles away` : null;

  const navigate = useNavigate();

  function handleViewMenu() {
    navigate("/kitchen/" + kitchenData.id);
  }

  return (
    <Card sx={{ width: 294 }}>
      <div style={{ position: 'relative' }}>
        <CardMedia
          sx={{ height: 140 }}
          image={aws_base_path + kitchenData.profilePic}
        />
      </div>
      <CardContent>
        <Typography gutterBottom variant="h6" component="div">
          {kitchenData.name}
        </Typography>
        {foodTypes.length > 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {foodTypes.map(type => FOOD_TYPE_LABELS[type] || type).join(' | ')}
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary">
          {distanceText ? `${servicesText} • ${distanceText}` : servicesText}
        </Typography>
      </CardContent>
      <CardActions style={{ display:'flex', justifyContent: 'center'}}>
        {/* <Button sx={{ textTransform: 'none', fontSize: 16}} size="small">Share</Button> */}
        <Button
          variant="outlined"
          size="small"
          onClick={handleViewMenu}
          sx={{
            textTransform: 'none',
            fontSize: 16,
            fontWeight: 500,
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            px: 2,
            borderRadius: 2,
            '&:hover': {
              borderColor: theme.palette.primary.dark,
              backgroundColor: 'rgba(46, 125, 50, 0.04)',
            },
          }}
        >
          Go To Menu
        </Button>
      </CardActions>
    </Card>
  );
}

Kitchen.propTypes = {
  kitchenData: PropTypes.object
}